/* eslint-disable import/prefer-default-export */
import React from 'react';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { MAIN_ICON_COLORS } from '../../Icon';

export const PersonalInfoUserSettingIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.USER_SETTINGS} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);

export const PersonalInfoCalendarIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.CALENDAR} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);

export const PersonalInfoAtSymbolIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px', minWidth: '2.3rem' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.AT_SYMBOL} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);

export const PersonalInfoPhoneIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.PHONE} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);
export const PersonalInfoShopIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3 flex-shrink-0"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.SHOP} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);
